import React from "react";

import { usePMIContext } from "../../../provider/private-medical-insurance.provider";

function PMIDescriptionTitle() {
  const { selectedStateCmsData } = usePMIContext();
  return (
    <h2
      className={`
        md:!text-3xl font-header-font text-center leading-[21px] 
        md:leading-[34.1px] text-[20px] md:mb-spacing-m mb-spacing-xs text-dark-text-title"
      `}
    >
      {selectedStateCmsData.title}
    </h2>
  );
}

export default PMIDescriptionTitle;
